import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeImageWrapperSkeleton } from './TypeImageWrapper';

export interface TypeBlockLogoCarouselFields {
    internalName: EntryFieldTypes.Symbol;
    title: EntryFieldTypes.Symbol;
    intro: EntryFieldTypes.RichText;
    logoGrid?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeImageWrapperSkeleton>>;
    logosCloudinary?: EntryFieldTypes.Object;
}

export type TypeBlockLogoCarouselSkeleton = EntrySkeletonType<TypeBlockLogoCarouselFields, 'blockLogoCarousel'>;
export type TypeBlockLogoCarousel<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockLogoCarouselSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockLogoCarousel<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockLogoCarousel<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockLogoCarousel';
}
